import met from '@viatsyshyn/ts-simple-query';

function revolverFor(formValues, account) {
  return (ref, condition) => {
    // console.log('Tags', account.tags);
    // console.log('ref', ref);
    // console.log('condition', condition);
    if (ref.startsWith('$account.tags')) {
      const tags = (account && account.tags) || [];
      return Array.isArray(condition)
        ? tags.some(_ => _ === condition.includes(_))
        : tags.some(_ => _ === condition);
    }

    if (ref.startsWith('$account.extdata')) {
      return account.extdata[ref.substr(16)];
    }

    if (ref.startsWith('$account.')) {
      return account[ref.substr(9)];
    }

    return formValues[ref];
  }
}

export default {
  methods: {
    meetsRequirements(field) {
      if (field && field.requires) {
        return met(field.requires, revolverFor(this.formValues, this.$root.currentUser));
      }
      return true;
    }
  }
}
